import { selfAxios } from "../../../../../axios/selfAxios.js";
async function postGetCustomerOrderListByOrderIdList(params) {
  const { data } = await selfAxios.post(`/designordercenterapi/internal/customerOrder/getCustomerOrderListByOrderIdList`, params);
  return data == null ? void 0 : data.data;
}
export { postGetCustomerOrderListByOrderIdList };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/request/designordercenter/internal/customerOrder/getCustomerOrderListByOrderIdList/post.js